module.exports = __webpack_public_path__ + "img/Pic_Bg_Fz_QWGH.37d72f20.png";